/**
 * @file Mo-Mentos, range support for momentjs
 * @author Wim Haanstra
 */
import * as moment from 'moment';
var Momentos = /** @class */ (function () {
    /**
     * Creates an instance of Momentos.
     * @param {moment.Moment} start The start of the range
     * @param {moment.Moment} end The end of the range
     * @param {number} [stepSize=1] The stepsize the loop should take
     * @param {moment.unitOfTime.DurationAs} [span='hour'] Step format
     * @param {moment.unitOfTime.StartOf} [endSpan='hour'] Step rounding
     * @param {boolean} [includeEdges=false] Include edges in the loop
     */
    function Momentos(start, end, stepSize, span, endSpan, includeEdges) {
        if (stepSize === void 0) { stepSize = 1; }
        if (span === void 0) { span = 'hour'; }
        if (endSpan === void 0) { endSpan = 'hour'; }
        if (includeEdges === void 0) { includeEdges = false; }
        this.start = start;
        this.end = end;
        this.stepSize = stepSize;
        this.span = span;
        this.endSpan = endSpan;
        this.includeEdges = includeEdges;
        this._cursor = moment(this.start);
    }
    Object.defineProperty(Momentos.prototype, "length", {
        get: function () {
            var i = 0;
            var iteratorResult = this.next();
            while (!iteratorResult.done) {
                i++;
                iteratorResult = this.next();
            }
            return i;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Checks if a range intersects with the current range
     *
     * @param {Momentos} range The 'other' range to check
     * @param {boolean} [includeEdges=true] Should edges of the range be included
     * @returns {boolean} Yes or no
     */
    Momentos.prototype.intersectsWith = function (range, includeEdges) {
        if (includeEdges === void 0) { includeEdges = true; }
        if (includeEdges) {
            return this.start < range.end && range.start < this.end;
        }
        else {
            return this.start < range.end && range.start < this.end;
        }
    };
    /**
     * Go to the next step in the iteration
     * @returns {IteratorResult<moment.Moment>} An Iterator result
     */
    Momentos.prototype.next = function () {
        if ((!this.includeEdges && this._cursor.isBefore(this.end, this.endSpan)) ||
            (this.includeEdges && this._cursor.isSameOrBefore(this.end, this.endSpan))) {
            var result = {
                done: false,
                value: moment(this._cursor)
            };
            this._cursor.add(this.stepSize, this.span);
            return result;
        }
        else {
            return {
                done: true,
                value: null
            };
        }
    };
    /**
     * The iterator
     *
     * @returns {IterableIterator<moment.Moment>} The iterator
     */
    Momentos.prototype[Symbol.iterator] = function () {
        return this;
    };
    return Momentos;
}());
export { Momentos };
